import { parse } from "util/parsers";
import { when } from "util/support";
import type { WithOnboardingStep, WithFieldsStatuses } from "features/onboarding/types";

export const useFieldsStatuses = () => {
    const parseFieldsStatuses = ({ fieldsStatuses }: WithFieldsStatuses) => (
        parse(String(fieldsStatuses))
    );

    const serializeFieldsStatuses = ({ fieldsStatuses }: Partial<WithFieldsStatuses>) => when(
        fieldsStatuses,
        JSON.stringify(fieldsStatuses),
        null
    );

    const withFieldsStatuses = <TStep extends object>(stepData: WithOnboardingStep<TStep>): WithOnboardingStep<TStep> => ({
        ...stepData,
        fieldsStatuses: parseFieldsStatuses(stepData)
    });

    return {
        withFieldsStatuses,
        parseFieldsStatuses,
        serializeFieldsStatuses
    };
};

export default useFieldsStatuses;
